import React from 'react'
import DOMPurify from "dompurify";
import { useSelector } from "react-redux";
import HeaderModal from 'layout/modals/HeaderModal';


const Biography = () => {
    const { biography } = useSelector((state) => state.content);

    return (
        <>
            <HeaderModal headerText={biography['header']}  headerTag={"h1"}/>
            <ul >
                {biography.paragraphs?.map((paragraph, index) => {
                    const safeHtml = DOMPurify.sanitize(`${paragraph}`, {
                        ALLOWED_TAGS: ["em", "br", "p", "strong", 'b', 'i', 'u'],
                        ALLOWED_ATTR: ["style"]
                    })
                    return <li style={{ listStyleType: "none" }} key={index.toString()} dangerouslySetInnerHTML={{ __html: safeHtml }} />
                })}
            </ul>
        </>
    )
}

export default Biography
